export default __webpack_public_path__ + "static/media/UnsellectedDropDown.16d434a7.svg";